<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

const store = useStore();
const route = useRoute();

const closeSidebarOnRouteChange = () => {
  store.state.argonConfig.isPinned = false;
};

const props = defineProps({
  to: {
    type: [Object, String],
    required: true,
  },
  miniIcon: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
});

const resolvedTo = computed(() => {
  if (typeof props.to === 'object') {
    return {
      ...props.to,
      params: {
        ...props.to.params,
        moduleSlug: route.params.moduleSlug || 'material-management'
      }
    };
  }
  // If it's a string path starting with /, we might need to prepend the slug
  if (typeof props.to === 'string' && props.to.startsWith('/') && !props.to.startsWith('/login') && !props.to.startsWith('/module-selection')) {
    const slug = route.params.moduleSlug || 'material-management';
    // Avoid double prefixing
    if (!props.to.startsWith(`/${slug}`)) {
      return `/${slug}${props.to}`;
    }
  }
  return props.to;
});
</script>
<template>
  <li class="nav-item">
    <router-link class="nav-link ms-3" :to="resolvedTo" @click="closeSidebarOnRouteChange">
      <span class="sidenav-mini-icon"> {{ miniIcon }} </span>
      <span class="sidenav-normal"> {{ text }} </span>
    </router-link>
  </li>
</template>
